/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "../contactForm/loaderApp";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.currentGoogle = exports.parseJwt = exports.insertAfter = exports.downloadFile = exports.viewportHeight = exports.viewportWidth = exports.selfDownload = exports.getUTMSource = exports.navigate = exports.currentHost = exports.currentLocation = exports.$ = exports.isMobile = exports.currentNavigator = exports.currentWindow = exports.currentDocument = void 0;
var __window = function () {
    return window;
};
var __navigator = function () {
    return navigator;
};
var __document = function () {
    return document;
};
var __checkMobile = function (a) {
    return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4));
};
exports.currentDocument = __document();
exports.currentWindow = __window();
exports.currentNavigator = __navigator();
exports.isMobile = __checkMobile(exports.currentNavigator.userAgent || exports.currentNavigator.vendor || exports.currentWindow.opera);
exports.$ = exports.currentWindow.jQuery;
exports.currentLocation = (exports.currentWindow) ? exports.currentWindow.location : null;
exports.currentHost = (exports.currentLocation) ? exports.currentLocation.protocol + "//" + exports.currentLocation.host : '';
exports.navigate = function (url, target) {
    if (target === void 0) { target = '_blank'; }
    if (url && exports.currentDocument) {
        try {
            var link = exports.currentDocument.createElement('a');
            link.setAttribute('href', '#');
            link.setAttribute('target', '_self');
            link.onclick = function (event) {
                // console.log('navigate', {event});
                event.preventDefault();
                setTimeout(function () {
                    exports.currentWindow.open(url, target);
                }, 100);
                return false;
            };
            link.click();
        }
        catch (e) {
            console.error({ url: url, e: e });
            exports.currentLocation && (exports.currentLocation.href = url);
        }
    }
};
exports.getUTMSource = function () {
    var _a;
    var url = new URL(exports.currentLocation.href);
    return (_a = url === null || url === void 0 ? void 0 : url.searchParams) === null || _a === void 0 ? void 0 : _a.get("utm_source");
};
exports.selfDownload = function (url) {
    if (url) {
        exports.currentLocation && (exports.currentLocation.href = url);
    }
};
exports.viewportWidth = exports.currentWindow.innerWidth - 20;
exports.viewportHeight = exports.currentWindow.innerHeight - 20;
exports.downloadFile = function (fileURL, fileName) {
    if (fileName === void 0) { fileName = null; }
    var filename = fileURL.substring(fileURL.lastIndexOf('/') + 1);
    // for non-IE
    if (!exports.currentWindow.ActiveXObject) {
        var save = document.createElement('a');
        save.href = fileURL;
        save.target = '_blank';
        save.download = fileName || filename;
        if (exports.currentNavigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) && exports.currentNavigator.userAgent.search("Chrome") < 0) {
            exports.currentDocument.location = save.href;
            // window event not working here
        }
        else {
            var evt = new MouseEvent('click', {
                'view': exports.currentWindow,
                'bubbles': true,
                'cancelable': false
            });
            save.dispatchEvent(evt);
            (exports.currentWindow.URL || exports.currentWindow.webkitURL).revokeObjectURL(save.href);
        }
    }
    // for IE < 11
    else if (!!exports.currentWindow.ActiveXObject && exports.currentDocument.execCommand) {
        var _window = exports.currentWindow.open(fileURL, '_blank');
        _window.document.close();
        _window.document.execCommand('SaveAs', true, fileName || filename);
        _window.close();
    }
};
exports.insertAfter = function (newNode, existingNode) {
    if (existingNode && newNode) {
        existingNode.parentNode.insertBefore(newNode, existingNode.nextSibling);
    }
};
exports.parseJwt = function (token) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    return JSON.parse(jsonPayload);
};
exports.currentGoogle = exports.currentWindow.google;


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var opener_1 = __webpack_require__(2);
opener_1.loadApp();


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.loadApp = void 0;
var browser_1 = __webpack_require__(0);
var cookies_1 = __webpack_require__(3);
var config_1 = __webpack_require__(4);
function closeDialog(elementId) {
    var result = 'success';
    try {
        browser_1.$(elementId).dialog('destroy').remove();
    }
    catch (e) {
        result = e;
    }
    return result;
}
function addClassStyle() {
    try {
        var sheet = browser_1.currentDocument.createElement('style');
        sheet.id = 'contact-form-style-for-dialog';
        sheet.innerHTML = ".ui-dialog.noUIStuffForContactForm .ui-dialog-titlebar {display:none !important;}\n        .ui-dialog.noUIStuffForContactForm {left: calc(50% - 250px)!important;top: 76px!important;box-shadow: 0px 3px 6px #00000029!important;border: none; padding:0; overflow:hidden; background: transparent; z-index: 99999999 !important; position: fixed;}\n        .ui-dialog.noUIStuffForContactForm .ui-dialog-content {border: none !important; padding:0 !important; overflow:hidden !important; background: transparent !important;}\n        .ui-widget.noUIStuffForContactForm  {border: none !important; padding:0 !important; overflow:hidden !important; background: transparent !important;}\n        .ui-widget-content.noUIStuffForContactForm  {border: none !important; padding:0 !important; overflow:hidden !important; background: transparent !important;}\n        .ui-dialog.noUIStuffForContactForm ~ .ui-widget-overlay {background: rgb(112, 112, 112)!important;opacity: .5!important;}";
        browser_1.currentDocument.body.appendChild(sheet);
    }
    catch (err) {
        console.log('addClassStyle ', { err: err });
    }
}
function generateFormURL(attributes) {
    var currentURL = (browser_1.currentLocation) ? browser_1.currentLocation.href || '' : '';
    var params = {
        screenId: attributes.cfScrId,
        screenTitle: attributes.cfScrTitle,
        formType: attributes.cfType,
        dialogId: config_1.Config.ADCORE_CONTACT_FORM_DIALOG_MODAL,
        navigateUrl: attributes.cfHref,
        downloadUrl: attributes.cfFile,
        currentUrl: currentURL,
        pricingProgramType: attributes.cfPPT,
        programType: attributes.cfProgramType,
        paymentTypeRequest: attributes.cfPaymentTypeRequest,
        pricingCurrency: attributes.cfPricingCurrency
    };
    var u = new URLSearchParams(params).toString();
    // console.log({params, u});
    return browser_1.currentHost + "/uiContactForm/?" + u;
}
function openDialog(attributes) {
    var status = false;
    try {
        var div = browser_1.currentDocument.getElementById(config_1.Config.ADCORE_CONTACT_FORM_DIALOG_MODAL);
        status = (div) ? browser_1.$("#" + config_1.Config.ADCORE_CONTACT_FORM_DIALOG_MODAL).dialog('isOpen') : false;
    }
    catch (e) {
    }
    if (!status) {
        //calc(100vw * 16 / 9)
        //width: 100vw; height: 100vh; margin: 0; padding: 0;
        //max-width: 501px; max-height: 658px;
        // width: 501,
        // height: 658,
        // width: 'auto',
        // height: 'auto',
        var vpWidth = browser_1.viewportWidth;
        var vpHeight = browser_1.viewportHeight;
        console.log('view port ', { vpWidth: vpWidth, vpHeight: vpHeight });
        if (vpWidth > 501) {
            vpWidth = 501;
        }
        else {
            vpWidth *= 0.5;
        }
        if (vpHeight >= 658) {
            vpHeight = 658;
        }
        else {
            vpHeight -= 20;
        }
        // min-height: -moz-available; min-height: -webkit-fill-available;  min-height: fill-available;
        var iframe = browser_1.$("<iframe src=\"" + generateFormURL(attributes) + "\" \n        style=\"box-sizing: border-box !important; min-height: -moz-available; min-height: -webkit-fill-available;\n        border:none; overflow:hidden !important; width: " + vpWidth + "px !important; height: " + vpHeight + "px !important; \n        margin: !important; padding: !important; max-width: 501px; max-height: 658px;border-radius: 10px;\"></iframe>");
        var dialog = browser_1.$("<div id=\"" + config_1.Config.ADCORE_CONTACT_FORM_DIALOG_MODAL + "\"></div>")
            .append(iframe)
            .appendTo('body')
            .dialog({
            autoOpen: false,
            draggable: false,
            closeOnEscape: true,
            stack: true,
            modal: true,
            resizable: false,
            width: 'auto',
            height: 'auto',
            maxWidth: 501,
            maxHeight: 658,
            dialogClass: 'noUIStuffForContactForm',
            appendTo: 'body',
            position: { my: 'center', at: 'center', of: browser_1.$('body') },
            open: function (event, ui) {
                browser_1.$('.ui-widget-overlay').bind('click', function () {
                    browser_1.$("#" + config_1.Config.ADCORE_CONTACT_FORM_DIALOG_MODAL).dialog('destroy').remove();
                });
            }
        });
        dialog.dialog('open');
    }
    else {
        browser_1.$('.ui-widget-overlay').bind('click', function () {
            browser_1.$("#" + config_1.Config.ADCORE_CONTACT_FORM_DIALOG_MODAL).dialog('destroy').remove();
        });
    }
}
function handleOneTapGoogleCredentialResponse(response) {
    var responsePayload = browser_1.parseJwt(response.credential);
    // console.log("ID: " + responsePayload.sub);
    // console.log('Full Name: ' + responsePayload.name);
    // console.log('Given Name: ' + responsePayload.given_name);
    // console.log('Family Name: ' + responsePayload.family_name);
    // console.log("Image URL: " + responsePayload.picture);
    // console.log('Email: ' + responsePayload.email);
    if (!responsePayload || !responsePayload.email || !responsePayload.name) {
        return;
    }
    var cookieToSave = { fullName: responsePayload.name, firstName: responsePayload.given_name || '',
        lastName: responsePayload.family_name || responsePayload.name,
        message: '', phone: null, email: responsePayload.email, provider: 'google' };
    // console.log('handleOneTapGoogleCredentialResponse: ', {responsePayload});
    var currentURL = (browser_1.currentLocation) ? browser_1.currentLocation.href || '' : '';
    var fields = [
        {
            name: 'firstname',
            value: responsePayload.given_name || '  '
        },
        {
            name: 'lastname',
            value: responsePayload.family_name || responsePayload.name
        },
        {
            name: 'email',
            value: responsePayload.email
        },
        {
            name: 'program',
            value: 'Blog subscribers'
        },
        {
            name: 'lead_source',
            value: 'Inbound'
        },
        {
            name: 'website_lead_made_with',
            value: 'Google One Tap'
        }
    ];
    var legalConsentOptions = {
        consent: {
            consentToProcess: true,
            text: 'I agree to allow Example Company to store and process my personal data.',
            communications: [
                {
                    value: true,
                    subscriptionTypeId: 999,
                    text: 'I agree to receive marketing communications from Example Company.'
                }
            ]
        }
    };
    var context = {
        pageUri: currentURL,
        pageName: currentURL
    };
    if (cookies_1.getCookie('hubspotutk')) {
        context.hutk = cookies_1.getCookie('hubspotutk') || '';
    }
    var params = { skipValidation: true, fields: fields, context: context, legalConsentOptions: legalConsentOptions };
    var PORTAL_ID = '6962858';
    var FORM_ID = '08fff184-36cf-44e5-8cdd-e35650783d70';
    var apiUrl = "https://api.hsforms.com/submissions/v3/integration/submit/" + PORTAL_ID + "/" + FORM_ID;
    browser_1.$.ajax({
        url: apiUrl,
        type: 'POST',
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        data: JSON.stringify(params),
        success: function (result) {
            console.log('success hsforms: ', { result: result });
            cookies_1.saveCookie(config_1.Config.ADCORE_CONTACT_FORM_COOKIE, cookieToSave);
        }
    });
}
function onClick(attributes) {
    // console.log(`cookie exist  ${!!getCookie(Config.ADCORE_CONTACT_FORM_COOKIE)}   and values: `, {
    //     cfType,
    //     cfScrId,
    //     cfScrTitle,
    //     cfHref
    // });
    if (cookies_1.getCookie(config_1.Config.ADCORE_CONTACT_FORM_COOKIE) && attributes.cfScrId) {
        if (['content', 'download_link'].includes(attributes.cfScrId)) {
            browser_1.navigate(attributes.cfHref);
            if (attributes.cfFile) {
                browser_1.selfDownload("https://cf-ng.adcore.com/download/?fileUrl=" + attributes.cfFile);
            }
            return;
        }
        if (['download'].includes(attributes.cfScrId)) {
            browser_1.selfDownload("https://cf-ng.adcore.com/download/?fileUrl=" + attributes.cfHref);
        }
    }
    if (!browser_1.isMobile) {
        openDialog(attributes);
    }
    else {
        browser_1.navigate(generateFormURL(attributes), '_self');
    }
}
exports.loadApp = function () {
    browser_1.currentWindow.handleOneTapGoogleCredentialResponse = handleOneTapGoogleCredentialResponse;
    addClassStyle();
    browser_1.currentWindow.deleteAdcoreFormCookie = function () {
        cookies_1.deleteCookie(config_1.Config.ADCORE_CONTACT_FORM_COOKIE);
    };
    browser_1.currentWindow.closeDialog = function (elementId, shouldNavigate, navigateUrl, downloadUrl) {
        closeDialog(elementId);
        shouldNavigate && browser_1.navigate(navigateUrl);
        shouldNavigate && downloadUrl && browser_1.selfDownload("https://cf-ng.adcore.com/download/?fileUrl=" + downloadUrl);
    };
    var buttons = browser_1.currentDocument.querySelectorAll('[data-contact-form-type]');
    buttons.forEach(function (button) {
        var cfType = button.getAttribute('data-contact-form-type') || 'portal';
        var cfScrId = button.getAttribute('data-contact-form-screen-id') || 'lets_talk';
        var cfScrTitle = button.getAttribute('data-contact-form-screen-title') || '';
        var cfHref = button.getAttribute('href') || button.getAttribute('data-contact-form-href') || '';
        var cfFile = button.getAttribute('data-contact-form-file') || '';
        var cfPPT = button.getAttribute('data-contact-form-ppt') || '';
        var cfProgramType = button.getAttribute('data-contact-form-program-type') || '';
        button.onclick = function (event) {
            if (event) {
                event.preventDefault();
            }
            var cfPaymentTypeRequest = cookies_1.getCookie('Payment Type Request') || '';
            var cfPricingCurrency = cookies_1.getCookie('Pricing Currency') || '';
            return onClick({ cfType: cfType, cfScrId: cfScrId, cfScrTitle: cfScrTitle, cfHref: cfHref, cfFile: cfFile, cfPPT: cfPPT, cfProgramType: cfProgramType, cfPaymentTypeRequest: cfPaymentTypeRequest, cfPricingCurrency: cfPricingCurrency });
        };
    });
    browser_1.currentWindow.onload = function () {
        // console.log('######check cookie######');
        var utm_source = browser_1.getUTMSource();
        if (utm_source) {
            cookies_1.saveUTMSourceCookie(utm_source);
        }
        if (!cookies_1.getCookie(config_1.Config.ADCORE_CONTACT_FORM_COOKIE)) {
            var initObject = {
                client_id: '230530490489-nqm7nta5rcvsbnmutuu62kl8edgnrjo9.apps.googleusercontent.com',
                callback: handleOneTapGoogleCredentialResponse,
                context: 'signin',
                auto_select: true,
                cancel_on_tap_outside: false,
                close_on_tap_outside: false,
                ux_mode: 'popup',
                prompt_parent_id: 'g_id_onload'
            };
            browser_1.currentGoogle.accounts.id.initialize(initObject);
            browser_1.currentGoogle.accounts.id.prompt(function (notify) {
                // console.log('notification: ',  {
                //     isDisplayMoment: notify.isDisplayMoment(),
                //     isDisplayed: notify.isDisplayed(),
                //     isNotDisplayed: notify.isNotDisplayed(),
                //     getNotDisplayedReason: notify.getNotDisplayedReason(),
                //     isSkippedMoment: notify.isSkippedMoment(),
                //     getSkippedReason: notify.getSkippedReason(),
                //     isDismissedMoment: notify.isDismissedMoment(),
                //     getDismissedReason: notify.getDismissedReason(),
                //     getMomentType: notify.getMomentType()
                // }, "prompting after delay");
            });
            if (!cookies_1.getCookie(config_1.Config.ADCORE_CONTACT_FORM_COOKIE_30_MINUTES)) {
                var currentURL = (browser_1.currentLocation) ? browser_1.currentLocation.href || '' : '';
                var hiddenDelayElements = browser_1.currentDocument.querySelectorAll('[data-contact-form-hidden-delay]');
                var e = (hiddenDelayElements && hiddenDelayElements.length) ? hiddenDelayElements[0] : null;
                // console.log(' currentWindow.onload: ', {currentURL, e});
                // public_html/wp-content/themes/sentrysite-corporate/category-blog.php
                // public_html/wp-content/themes/sentrysite-corporate/single.php
                if (e || currentURL.includes('/blog/')) {
                    var delay = (e) ? e.getAttribute('data-contact-form-hidden-delay') || '10000' : '10000';
                    var cfType_1 = (e) ? e.getAttribute('data-contact-form-type') || 'blogPopup' : 'blogPopup';
                    var cfScrId_1 = (e) ? e.getAttribute('data-contact-form-screen-id') || 'blog_form' : 'blog_form';
                    var cfProgramType_1 = (e) ? e.getAttribute('data-contact-form-program-type') || 'Blog subscribers' : 'Blog subscribers';
                    var cfScrTitle_1 = '';
                    var cfHref_1 = '';
                    var cfFile_1 = '';
                    var cfPPT_1 = '';
                    var cfPaymentTypeRequest_1 = '';
                    var cfPricingCurrency_1 = '';
                    // console.log(' currentWindow.onload before time out: ', {currentURL, delay});
                    setTimeout(function () {
                        // console.log(' currentWindow.onload before onClick', {currentURL, delay});
                        return onClick({
                            cfType: cfType_1,
                            cfScrId: cfScrId_1,
                            cfScrTitle: cfScrTitle_1,
                            cfHref: cfHref_1,
                            cfFile: cfFile_1,
                            cfPPT: cfPPT_1,
                            cfProgramType: cfProgramType_1,
                            cfPaymentTypeRequest: cfPaymentTypeRequest_1,
                            cfPricingCurrency: cfPricingCurrency_1
                        });
                    }, parseInt(delay));
                }
            }
        }
    };
};


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.saveUTMSourceCookie = exports.saveCookie = exports.deleteCookie = exports.getCookie = void 0;
var browser_1 = __webpack_require__(0);
function getCookie(cname) {
    if (browser_1.currentDocument.cookie) {
        var name_1 = cname + "=";
        var decodedCookie = decodeURIComponent(browser_1.currentDocument.cookie);
        var ca = decodedCookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name_1) == 0) {
                return c.substring(name_1.length, c.length);
            }
        }
    }
    return "";
}
exports.getCookie = getCookie;
function deleteCookie(cname) {
    var date = new Date();
    // Set it expire in -1 days
    date.setTime(date.getTime() + (-1 * 24 * 60 * 60 * 1000));
    // Set it
    document.cookie = cname + "=; expires=" + date.toUTCString() + "; path=/";
}
exports.deleteCookie = deleteCookie;
function saveCookie(cname, dataToSave) {
    var d = new Date();
    // d.setDate(d.getDate() + 365 * 10); // 10 years
    d.setTime(d.getTime() + (72 * 60 * 60 * 1000)); // 72 hours
    document.cookie = cname + "=" + encodeURIComponent(JSON.stringify(dataToSave)) + ";expires=" + d.toUTCString() + ";path=/";
}
exports.saveCookie = saveCookie;
function saveUTMSourceCookie(utm_source) {
    var d = new Date();
    d.setDate(d.getDate() + 1);
    document.cookie = "adcoreUtmSourceToken=" + utm_source + ";expires=" + d.toUTCString() + ";path=/";
}
exports.saveUTMSourceCookie = saveUTMSourceCookie;


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Config = void 0;
// for next usage
var Config = /** @class */ (function () {
    function Config() {
    }
    Config.ADCORE_CONTACT_FORM_DIALOG_MODAL = 'ADCORE-CONTACT-FORM-DIALOG-MODAL';
    Config.ADCORE_CONTACT_FORM_COOKIE = 'adcoreContactFormToken';
    Config.ADCORE_CONTACT_FORM_COOKIE_30_MINUTES = 'adcoreContactFormToken_30_minutes';
    return Config;
}());
exports.Config = Config;


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// loader.min.js